import React from "react";
import ObscurityPattern from "./patterns/ObscurityPattern";

const BLOCK_COUNT = 6 * 3;

const GlassBlockDiagram = () => (
  <div className="flex justify-center items-center">
    <div className="grid grid-cols-6 gap-1 w-72 h-36 bg-brand border-8 border-brand">
      {Array.from({ length: BLOCK_COUNT }, (_, index) => (
        <div key={index} className="relative bg-light overflow-hidden">
          <ObscurityPattern />
        </div>
      ))}
    </div>
  </div>
);

export default GlassBlockDiagram;
